import { required, useTranslate } from 'ra-core';
import {
  SelectInput,
  type SelectInputProps,
} from '../../components/admin/select-input';

const JOURNEY_THUMBNAILS = [
  {
    id: 'https://files.prod.aws.joinmoonstar.app/public/demo/grow-activity-Course.svg',
    name: 'moonstar.journeys.activityTypes.course',
  },
  {
    id: 'https://files.prod.aws.joinmoonstar.app/public/demo/grow-activity-InPerson.svg',
    name: 'moonstar.journeys.activityTypes.inPerson',
  },
  {
    id: 'https://files.prod.aws.joinmoonstar.app/public/demo/grow-activity-Live.svg',
    name: 'moonstar.journeys.activityTypes.live',
  },
  {
    id: 'https://files.prod.aws.joinmoonstar.app/public/demo/grow-activity-PDF.svg',
    name: 'moonstar.journeys.activityTypes.pdf',
  },
  {
    id: 'https://files.prod.aws.joinmoonstar.app/public/demo/grow-activity-Quiz.svg',
    name: 'moonstar.journeys.activityTypes.quiz',
  },
  {
    id: 'https://files.prod.aws.joinmoonstar.app/public/demo/grow-activity-Survey.svg',
    name: 'moonstar.journeys.activityTypes.survey',
  },
  {
    id: 'https://files.prod.aws.joinmoonstar.app/public/demo/grow-activity-Video.svg',
    name: 'moonstar.journeys.activityTypes.video',
  },
];

export const ActivityTypeInput = (props: SelectInputProps) => {
  const translate = useTranslate();

  return (
    <SelectInput
      label="moonstar.journeys.activityType"
      validate={required()}
      optionText={(value: { id: string; name: string }) => (
        <span className="flex items-center gap-1.5">
          <img src={value.id} alt="" className="size-6 shrink-0" />
          <span>{translate(value.name)}</span>
        </span>
      )}
      choices={JOURNEY_THUMBNAILS}
      {...props}
    />
  );
};
